@if (config) {
  <section class="ErrorEmpty">
    @if (config.image_url) {
      <img
        class="ErrorEmpty__Image"
        [src]="config.image_url"
        [attr.alt]="config.alt || 'Error Empty Image'"
      />
    }
    <div>
      @if (config.title) {
        <h4 class="ErrorEmpty__Title">{{ config.title }}</h4>
      }
      @if (config.description) {
        <p class="ErrorEmpty__Description" [innerHTML]="config.description"></p>
      }
    </div>
  </section>
}
